module.exports = __webpack_public_path__ + "static/media/user-update-acc.517c6acb.jpg";